import React from 'react';
import { FileText, Download, Eye, Save } from 'lucide-react';

const HeroSection = ({ onGetStarted }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-900 via-purple-900 to-pink-900 text-white relative overflow-hidden">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-32 w-80 h-80 bg-purple-500 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-pulse"></div>
        <div className="absolute -bottom-40 -left-32 w-80 h-80 bg-indigo-500 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-pulse delay-1000"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-80 h-80 bg-pink-500 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-pulse delay-500"></div>
      </div>

      <div className="relative z-10 container mx-auto px-4 py-20">
        <div className="text-center">
          <div className="mb-8">
            <div className="inline-flex items-center justify-center p-4 bg-white/10 backdrop-blur-sm rounded-2xl mb-6">
              <FileText className="h-16 w-16 text-white" />
            </div>
            <h1 className="text-5xl md:text-7xl font-bold mb-6 bg-gradient-to-r from-white via-indigo-200 to-purple-200 bg-clip-text text-transparent">
              Professional Invoice Generator
            </h1>
            <p className="text-xl md:text-2xl text-indigo-200 mb-8 max-w-3xl mx-auto leading-relaxed">
              Create stunning, professional invoices in minutes. No registration required, completely free, and works offline.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <button
              onClick={onGetStarted}
              className="bg-white text-indigo-900 px-8 py-4 rounded-2xl font-semibold text-lg hover:bg-indigo-50 transition-all duration-200 shadow-2xl hover:shadow-white/20 transform hover:scale-105"
            >
              Create Your First Invoice
            </button>
            <button className="border-2 border-white/30 text-white px-8 py-4 rounded-2xl font-semibold text-lg hover:bg-white/10 transition-all duration-200 backdrop-blur-sm">
              Watch Demo
            </button>
          </div>

          {/* Features Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 hover:bg-white/20 transition-all duration-200">
              <Download className="h-12 w-12 text-indigo-300 mx-auto mb-4" />
              <h3 className="text-xl font-semibold mb-2">Instant PDF Export</h3>
              <p className="text-indigo-200">Download professional PDFs instantly with a single click.</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 hover:bg-white/20 transition-all duration-200">
              <Eye className="h-12 w-12 text-purple-300 mx-auto mb-4" />
              <h3 className="text-xl font-semibold mb-2">Live Preview</h3>
              <p className="text-purple-200">See your invoice update in real-time as you type.</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 hover:bg-white/20 transition-all duration-200">
              <Save className="h-12 w-12 text-pink-300 mx-auto mb-4" />
              <h3 className="text-xl font-semibold mb-2">Save & Manage</h3>
              <p className="text-pink-200">Save invoices locally and manage all your billing.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;